var _rect, _path, _circle, _circle2, _circle3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOms(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 61,
    viewBox: "0 0 82 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 69.9981,
    height: 56.5853,
    rx: 11,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.8979C0 4.87916 4.87916 0 10.8979 0H59.1002C65.1189 0 69.9981 4.87916 69.9981 10.8979H0Z",
    fill: "#18C347"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.01175,
    cy: 4.82016,
    r: 1.6766,
    fill: "#305F1A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.0894,
    cy: 4.82016,
    r: 1.6766,
    fill: "#96D36E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.1671,
    cy: 4.82016,
    r: 1.6766,
    fill: "#519F2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M7.33516 18.2101C7.33632 17.4051 7.57621 16.6186 8.02447 15.9499C8.47274 15.2813 9.10924 14.7606 9.85347 14.4537C10.5977 14.1469 11.4162 14.0676 12.2055 14.2261C12.9948 14.3845 13.7193 14.7734 14.2875 15.3437C14.8557 15.9139 15.242 16.6399 15.3975 17.4297C15.5531 18.2195 15.4709 19.0378 15.1613 19.7809C14.8518 20.524 14.3288 21.1586 13.6585 21.6044C12.9882 22.0503 12.2008 22.2873 11.3958 22.2855C10.8615 22.2849 10.3325 22.179 9.83913 21.9738C9.34578 21.7686 8.89772 21.4682 8.52058 21.0897C8.14344 20.7112 7.84462 20.262 7.64121 19.7679C7.43781 19.2738 7.33381 18.7445 7.33516 18.2101Z",
    fill: "#18C347"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M15.4742 28.3865C15.4741 29.1915 15.2352 29.9784 14.7878 30.6476C14.3405 31.3169 13.7046 31.8384 12.9608 32.1462C12.2169 32.454 11.3985 32.5343 10.609 32.3769C9.81956 32.2195 9.0945 31.8315 8.52557 31.262C7.95663 30.6925 7.5694 29.967 7.41284 29.1774C7.25629 28.3877 7.33745 27.5694 7.64605 26.8259C7.95466 26.0823 8.47685 25.4471 9.14656 25.0004C9.81628 24.5537 10.6034 24.3157 11.4084 24.3164C11.9427 24.3166 12.4716 24.4221 12.9651 24.6268C13.4585 24.8314 13.9068 25.1313 14.2844 25.5093C14.662 25.8872 14.9614 26.3358 15.1655 26.8295C15.3696 27.3232 15.4745 27.8522 15.4742 28.3865ZM11.4074 30.4264C11.8095 30.4248 12.2021 30.304 12.5356 30.0794C12.8691 29.8548 13.1285 29.5364 13.2811 29.1644C13.4337 28.7924 13.4726 28.3835 13.3929 27.9894C13.3132 27.5953 13.1185 27.2336 12.8334 26.9501C12.5482 26.6666 12.1855 26.474 11.7909 26.3966C11.3964 26.3192 10.9877 26.3604 10.6166 26.5152C10.2455 26.6699 9.92854 26.9312 9.70585 27.266C9.48315 27.6007 9.36468 27.994 9.3654 28.3961C9.3687 28.9356 9.58527 29.4518 9.96784 29.8322C10.3504 30.2125 10.8679 30.4261 11.4074 30.4263V30.4264Z",
    fill: "#18C347"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M27.6854 16.1929V18.1898H17.5303V16.1929H27.6854Z",
    fill: "#18C347"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M27.6823 24.3045H17.5345V22.3013H27.6823V24.3045Z",
    fill: "#18C347"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M17.5161 30.4126C17.5161 29.7734 17.5161 29.1552 17.5172 28.5349C17.5192 28.4943 17.5235 28.4538 17.53 28.4136H27.6853V30.4126H17.5161Z",
    fill: "#18C347"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M24.6271 47.0776H15.1199V60.8231H24.6271V47.0776Z",
    fill: "#18C347"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M36.0817 35.623H26.5745V60.823H36.0817V35.623Z",
    fill: "#18C347"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M47.4215 40.2051H38.0288V60.8232H47.4215V40.2051Z",
    fill: "#18C347"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M58.6469 24.3979H49.2542V60.8233H58.6469V24.3979Z",
    fill: "#18C347"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M70.3306 30.0107H60.8234V60.8234H70.3306V30.0107Z",
    fill: "#18C347"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M81.3268 38.4868H71.8196V60.8231H81.3268V38.4868Z",
    fill: "#18C347"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOms);
export default __webpack_public_path__ + "static/media/oms.a3953de2caaa73cec6afc48631afbe9c.svg";
export { ForwardRef as ReactComponent };